import { useAuthContext } from '../context/AuthContext'

// Role hierarchy
// owner     - full access including billing, config, all features
// hr_admin  - full HR access, no billing/client config
// supervisor - department-level access only
// employee  - standard employee portal

export const ROLES = {
  OWNER: 'owner',
  HR_ADMIN: 'hr_admin',
  SUPERVISOR: 'supervisor',
  EMPLOYEE: 'employee',
  ADMIN: 'admin', // legacy - maps to hr_admin
}

export const ROLE_LABELS = {
  owner: 'Owner',
  hr_admin: 'HR Administrator',
  supervisor: 'Supervisor',
  employee: 'Employee',
  admin: 'Administrator',
}

export const ROLE_COLORS = {
  owner: '#B8734A',
  hr_admin: '#4A7C59',
  supervisor: '#4A6B8A',
  employee: '#6B7D6B',
  admin: '#4A7C59',
}

// Permission checks
export function useRole() {
  const { role, profile } = useAuthContext()
  const r = role || 'employee'

  const isOwner      = r === 'owner'
  const isHRAdmin    = r === 'hr_admin' || r === 'admin'
  const isSupervisor = r === 'supervisor'
  const isEmployee   = r === 'employee'
  const isAdminLevel = isOwner || isHRAdmin

  return {
    role: r,
    label: ROLE_LABELS[r] || r,
    color: ROLE_COLORS[r] || '#6B7D6B',
    isOwner,
    isHRAdmin,
    isSupervisor,
    isEmployee,
    isAdminLevel,
    department: profile?.department || null,

    // Feature permissions
    can: {
      viewAllEmployees:    isOwner || isHRAdmin,
      viewDeptOnly:        isSupervisor,
      editEmployees:       isOwner || isHRAdmin,
      approveTime:         isOwner || isHRAdmin || isSupervisor,
      approveTimeOff:      isOwner || isHRAdmin || isSupervisor,
      viewPerformance:     isOwner || isHRAdmin || isSupervisor,
      editPerformance:     isOwner || isHRAdmin,
      sendMemos:           isOwner || isHRAdmin,
      manageDocuments:     isOwner || isHRAdmin,
      viewHelpdesk:        isOwner || isHRAdmin,
      manageHelpdesk:      isOwner || isHRAdmin,
      viewCalendar:        isOwner || isHRAdmin || isSupervisor,
      editCalendar:        isOwner || isHRAdmin,
      viewVisitors:        isOwner || isHRAdmin,
      manageVisitors:      isOwner || isHRAdmin,
      clientConfig:        isOwner || isHRAdmin,
      devRequests:         isOwner || isHRAdmin,
      viewReports:         isOwner || isHRAdmin,
    }
  }
}
